"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultSfilterPriceGroupState = void 0;
var SfilterKey_1 = require("@/pages/common/states/sfilter/SfilterKey");
var SfilterPriceGroup_1 = require("@/pages/common/states/sfilter/sections/SfilterPriceGroup");
var SfilterTypeGroup_1 = require("@/pages/common/states/sfilter/sections/SfilterTypeGroup");
var SfilterPriceOptionMode_init_1 = require("@/pages/common/states/sfilter/sections/price/SfilterPriceOptionMode.init");
exports.defaultSfilterPriceGroupState = {
    key: SfilterKey_1.SfilterKey.PRICE,
    name: 'Price',
    nameCustom: 'Custom',
    namePriceRange: 'Price Range',
    nameUnlimited: 'Unlimited',
    nameTo: 'to',
    opened: true,
    currency: SfilterPriceGroup_1.SfilterCurrency.HKD,
    mode: SfilterTypeGroup_1.SfilterType.RENT,
    optionMode: SfilterPriceOptionMode_init_1.defaultSfilterPriceOptionModeState,
};
